import React from 'react';
import { SVGProps } from '../../../types/svgs';
import { VolksKlickLogo } from './Logo';
import { VolksKlickLogotype } from './Logotype';

interface Props extends SVGProps {
  logoOnly?: boolean;
  iconAriaHidden?: boolean;
};

export const VolksKlickBrand = ({
  logoOnly = false,
  iconAriaHidden,
  className,
  title,
  ariaHidden,
  ariaLabel,
  tabIndex,
  ref
}: Props) => {
  return (
    logoOnly
    ? <VolksKlickLogo
        className={className}
        title={title}
        ariaHidden={iconAriaHidden || ariaHidden}
        ariaLabel={ariaLabel}
        tabIndex={tabIndex}
        ref={ref}
      />
    : <VolksKlickLogotype
        className={className}
        title={title}
        ariaHidden={iconAriaHidden || ariaHidden}
        ariaLabel={ariaLabel}
        tabIndex={tabIndex}
        ref={ref}
      />
  );
};
